import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray } from '../../../../web/styles/colors';
import { background, orange, success } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	floatingButton: {
		position: 'absolute',
		right: 40,
		top: 20,
		zIndex: 1,
	},
	floatingPanel: {
		background,
		borderRadius: 8,
		padding: 8,
		position: 'absolute',
		left: 100,
		top: 160,
		zIndex: 8,
		boxShadow: '0px 0px 16px rgba(139, 139, 139, 1)',
		maxWidth: 466, // 450 + 26 px padding total
	},
	buttonToggleGroup: {
		width: 60,
		display: 'flex',
		height: '100%',
		gap: 8,
	},
	buttonToggle: {
		width: 30,
		textAlign: 'center',
	},
	activeButtonToggle: {
		border: '1px solid black',
	},
	header: {
		display: 'flex',
		gap: 8,
	},
	message: {
		fontSize: 14,
		marginTop: 12,
	},
	suggestionsContainer: {
		padding: 16,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		maxHeight: 500,
		overflow: 'auto',
	},
	pillButton: {
		height: 52,
		width: 200,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	redPill: {
		color: orange,
		borderColor: orange,
		borderRadius: 26,
		background: 'rgba(248, 145, 67, 0.2)',
	},
	greenPill: {
		color: success,
		borderColor: success,
		borderRadius: 26,
		background: 'rgba(113, 172, 54, 0.2)',
	},
	pillButtonGroup: {
		display: 'flex',
		gap: 12,
	},
	paragraph: {
		fontSize: 14,
	},
	iconGroup: {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
	},
	iconButton: {
		cursor: 'pointer',
		background: 'none',
		border: 'none',
		padding: '4px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	modalContainer: {
		padding: '24px',
		maxWidth: '700px',
		width: '100%',
		maxHeight: '80vh',
		display: 'flex',
		flexDirection: 'column',
	},
	modalHeader: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: '16px',
		gap: '8px',
	},
	modalIcon: {
		fill: brandPrimary,
		color: brandPrimary,
		width: '20px',
		height: '20px',
	},
	modalTitle: {
		margin: 0,
		fontSize: '18px',
		fontWeight: 600,
		color: charmGray,
	},
	modalContent: {
		fontSize: '14px',
		lineHeight: '1.6',
		flex: 1,
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '24px',
		gap: '12px',
	},
	loadingContainerWithColor: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '24px',
		gap: '12px',
		color: brandPrimary,
	},
	loadingText: {
		fontSize: '14px',
		color: charmGray,
	},
	conversationContainer: {
		flex: 1,
		overflowY: 'auto',
		marginBottom: '16px',
		minHeight: '200px',
	},
	messageContainer: {
		marginBottom: '16px',
		padding: '8px 12px',
		borderRadius: '8px',
		wordWrap: 'break-word',
		overflowWrap: 'break-word',
		wordBreak: 'break-word',
	},
	userMessage: {
		backgroundColor: '#f0f8ff',
		borderLeft: `3px solid ${brandPrimary}`,
	},
	assistantMessage: {
		backgroundColor: '#f9f9f9',
		borderLeft: '3px solid #e0e0e0',
	},
	messageRole: {
		fontSize: '12px',
		fontWeight: 600,
		marginBottom: '4px',
		color: charmGray,
		textTransform: 'uppercase',
	},
	inputContainer: {
		borderTop: '1px solid #e0e0e0',
		paddingTop: '16px',
		marginTop: '16px',
	},
	textarea: {
		width: '100%',
		minHeight: '80px',
		padding: '12px',
		border: '1px solid #ccc',
		borderRadius: '4px',
		fontSize: '14px',
		fontFamily: 'inherit',
		resize: 'vertical',
		marginBottom: '12px',
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '8px',
	},
	streamingIndicator: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		fontSize: '12px',
		color: charmGray,
		fontStyle: 'italic',
		marginLeft: '8px',
	},
	messageContent: {
		// Allow react-markdown to handle its own spacing and formatting
		'& > *:first-child': {
			marginTop: 0,
		},
		'& > *:last-child': {
			marginBottom: 0,
		},
	},
	// AI Modal Draggable Styles
	aiModalContainer: {
		background,
		borderRadius: 8,
		padding: 8,
		boxShadow: '0px 0px 16px rgba(139, 139, 139, 1)',
		maxWidth: 700,
		width: 700,
		maxHeight: '80vh',
		display: 'flex',
		flexDirection: 'column',
		position: 'absolute',
		left: 200,
		top: 100,
		zIndex: 9,
	},
	aiModalHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 12,
		padding: '12px 16px',
		borderBottom: '1px solid #e0e0e0',
	},
	aiModalHeaderContent: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	aiModalHeaderActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	aiModalContent: {
		fontSize: 14,
		lineHeight: 1.6,
		flex: 1,
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		padding: '0 16px 16px 16px',
	},
});
